<template>
  <div class="d-flex flex-row justify-content-center fs-8px ">
    <i v-if="score <= 0" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 0.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>

    <i v-if="score <= 1" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 1.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>


    <i v-if="score <= 2" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 2.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>

    <i v-if="score <= 3" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 3.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>

    <i v-if="score <= 4" class="far fa-star text-orange-300"></i>
    <i v-else-if="score <= 4.5" class="fas fa-star-half-stroke text-orange-300"></i>
    <i v-else class="fas fa-star text-orange-300"></i>
  </div>
</template>

<script>
export default {
  name: 'Rating',
  props: ['score'],
  data() {
    return {

    }
  }
}
</script>